// extracted by mini-css-extract-plugin
export default {"loader":"Spinner1_loader__K4RjQ","mltShdSpin":"Spinner1_mltShdSpin__9cJUf","round":"Spinner1_round__0-uzh"};